var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"color":_vm.success ? 'success' : _vm.color},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$props,false),[(!_vm.success)?_vm._t("default"):[_c('v-icon',[_vm._v("mdi-check")]),_vm._v(_vm._s(_vm.$t('Saved'))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }